<script setup lang="ts">
import BaseHeader from '@/components/base/BaseHeader.vue'
import BaseToast from '@/components/base/BaseToast.vue'
import { useRoute } from 'vue-router'

const route = useRoute()
</script>

<template>
  <BaseHeader v-if="!route.meta.hideHeader" />
  <BaseToast />
  <router-view />
</template>

<style scoped></style>
